class HttpDim {
  constructor($http, $q, contentLoaderService) {
    this.$http = $http;
    this.$q = $q;
    this.contentLoaderService = contentLoaderService;
    this.methodsWithDataParam = ['put', 'patch','post', 'delete'];
  }

  get(url, config, methodShouldShowContentLoader) {
    var cacheBustedUrl = this.appendCacheBust(url);

    return this.wrap$httpRequest('get', cacheBustedUrl, undefined, config, methodShouldShowContentLoader);
  }

  delete(url, config) {
    return this.wrap$httpRequest('delete', url, undefined, config);
  }

  head(url, config) {
    return this.wrap$httpRequest('head', url, undefined, config);
  }
   
  jsonp(url, config) {
    return this.wrap$httpRequest('jsonp', url, undefined, config);
  }

  post(url, data, config, methodShouldShowContentLoader = true) {
    return this.wrap$httpRequest('post', url, data, config, methodShouldShowContentLoader);
  }

  put(url, data, config) {
    return this.wrap$httpRequest('put', url, data, config);
  }

  patch(url, data, config) {
    return this.wrap$httpRequest('patch', url, data, config);
  }

  wrap$httpRequest(method, url, data, config, methodShouldShowContentLoader) {
    var deferred = this.$q.defer();
    this.showContentLoader(method, methodShouldShowContentLoader);

    return this.configureAndSend$httpRequest(method, url, data, config,methodShouldShowContentLoader).then((result) => {
      deferred.resolve(result);
      this.hideContentLoader(method, methodShouldShowContentLoader);

      return deferred.promise;
    }, (reason) => {
      deferred.reject(reason);
      this.hideContentLoader(method, methodShouldShowContentLoader);

      return deferred.promise;
    }, (update) => {

      deferred.notify(update);
      this.hideContentLoader(method, methodShouldShowContentLoader);

      return deferred.promise;
    });
  }

  configureAndSend$httpRequest(method, url, data, config, methodShouldShowContentLoader) {
    if (this.requestMethodToShowContentLoader(method, methodShouldShowContentLoader)) {
      return this.$http[method](url, data, config);
    }

    return this.$http[method](url, config);
  }

  showContentLoader(method, methodShouldShowContentLoader) {
    if (this.requestMethodToShowContentLoader(method, methodShouldShowContentLoader)) {
      this.contentLoaderService.show();
    }
  }

  hideContentLoader(method, methodShouldShowContentLoader) {
    if (this.requestMethodToShowContentLoader(method, methodShouldShowContentLoader)) {
      this.contentLoaderService.hide();
    }
  }

  requestMethodToShowContentLoader(method, methodShouldShowContentLoader) {
    return (this.methodsWithDataParam.indexOf(method) > -1) || methodShouldShowContentLoader;
  }

  appendCacheBust(url) {
    var separator = url.indexOf('?') === -1 ? '?cb=' : '&cb=';

    return url + separator + new Date().getMilliseconds();
  }

}

HttpDim.$inject = ['$http', '$q', 'contentLoaderService'];

export
default HttpDim;


// WEBPACK FOOTER //
// ./app/common/httpDim/httpDim.service.js